import { Investor } from './../shared/models/investor';
import { AssetService } from './../../services/asset.service';
import { CategoryDataService } from './../../services/category-data.service';
import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import * as md5 from 'md5';
import {
  AssetPage,
  BondsFields,
  FDFields,
  MutualFundsFields,
  CashFields,
  DirectEquityFields,
  RealEstateFields,
  PreciousMetalsFields,
  InternationalEquityFields,
  PMSFields
} from '../asset-selection/asset-catalog/types';

// import basic from '../../../environments/data/basic

@Component({
  selector: 'app-file-settings',
  templateUrl: './file-settings.component.html',
  styleUrls: ['./file-settings.component.css']
})
export class FileSettingsComponent implements OnInit {
  data = '1';
  investor: Investor;
  pages = AssetPage;

  constructor(
    private __categoryService: CategoryDataService,
    private __assetService: AssetService
  ) {}

  ngOnInit() {
    // this.data = "1";
  }

  onKey(value: string) {
    this.data = value;
  }

  sendData() {
    // const data = basic;
  }

  onFileChange(evt: any, category) {
    console.log(evt);
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>evt.target;
    console.log('reading from file');
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    console.log('reading from file');
    const reader: FileReader = new FileReader();
    console.log('reading from file', reader);
    reader.onerror = error => {
      console.log(error);
    };
    reader.onload = (e: any) => {
      /* read workbook */
      console.log('reading from file');
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      let generatedData = {};
      console.log('file is open now');
      wb.SheetNames.forEach(element => {
        console.log(element);
        const ws: XLSX.WorkSheet = wb.Sheets[element];
        const currentData = XLSX.utils.sheet_to_json(ws)[0];
        // console.log(currentData);
        generatedData = {
          ...generatedData,
          [element]: {
            name: currentData['name'],
            values: {
              cash: currentData['cash'],
              comodities: currentData['comodities'],
              debt: currentData['debt'],
              equity: currentData['equity'],
              other_assets: currentData['other_assets'],
              precious_metals: currentData['precious_metals'],
              real_estate: currentData['real_estate']
            },
            expected_return: currentData['expected_return']
          }
        };
      });
      console.log(generatedData);

      if (confirm('Are you sure you want to load these configuration')) {
        this.__categoryService.addCategoryData(
          JSON.stringify(generatedData),
          category,
          value => {
            console.log(value);
          },
          error => {
            console.log(error);
          }
        );
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  onAssetFileChange(evt: any, assetType) {
    console.log(evt);
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>evt.target;
    console.log('reading from file');
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    console.log('reading from file');
    const reader: FileReader = new FileReader();
    console.log('reading from file', reader);
    reader.onerror = error => {
      console.log(error);
    };
    let currentData;
    reader.onload = (e: any) => {
      /* read workbook */
      console.log('reading from file');
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      console.log('file is open now');
      wb.SheetNames.forEach(element => {
        console.log(element);
        const ws: XLSX.WorkSheet = wb.Sheets[element];
        currentData = XLSX.utils.sheet_to_json(ws);
      });

      const hashedData = currentData.map(item => {
        return {
          ...item,
          hash: this.generateHash(item, assetType)
        };
      });

      console.log(hashedData);
      if (confirm('Are you sure you want to load these configuration')) {
        this.__assetService.addAsset(
          JSON.stringify(hashedData),
          assetType,
          value => {
            console.log(value);
            alert('New Data has been updated');
          },
          error => {
            console.log(error);
            alert(
              'There were some errors while setting new settings, Please contact support to resolve the issue.'
            );
          }
        );
      }
    };

    reader.readAsBinaryString(target.files[0]);
  }

  generateHash(item, assetType) {
    switch (assetType) {
      case this.pages.bonds:
        return md5(
          item[BondsFields.name] +
            '||' +
            item[BondsFields.type] +
            '||' +
            item[BondsFields.roi] +
            '||' +
            item[BondsFields.maturity] +
            '||' +
            item[BondsFields.registrar] +
            '||' +
            item[BondsFields.price]
        );
      case this.pages.mf:
        return md5(
          item[MutualFundsFields.name] +
            '||' +
            item[MutualFundsFields.size] +
            '||' +
            item[MutualFundsFields.options] +
            '||' +
            item[MutualFundsFields.benchmark] +
            '||' +
            item[MutualFundsFields.risk] +
            '||' +
            item[MutualFundsFields.timeframe] +
            '||' +
            item[MutualFundsFields.tax] +
            '||' +
            item[MutualFundsFields.amc] +
            '||' +
            item[MutualFundsFields.scheme] +
            '||' +
            item[MutualFundsFields.class] +
            '||'
        );
      case this.pages.fd:
        return md5(
          item[FDFields.nbfc] +
            '||' +
            item[FDFields.bank] +
            '||' +
            item[FDFields.category] +
            '||' +
            item[FDFields.roi] +
            '||' +
            item[FDFields.tax] +
            '||' +
            item[FDFields.duration]
        );
      case this.pages.cash:
        return md5(item[CashFields.name] + '||' + item[CashFields.type]);
      case this.pages.de:
        return md5(
          item[DirectEquityFields.name] + '||' + item[DirectEquityFields.type]
        );
      case this.pages.re:
        return md5(
          item[RealEstateFields.name] + '||' + item[RealEstateFields.type]
        );
      case this.pages.pm:
        return md5(
          item[PreciousMetalsFields.name] +
            '||' +
            item[PreciousMetalsFields.type]
        );
      case this.pages.iequity:
        return md5(
          item[InternationalEquityFields.name] +
            '||' +
            item[InternationalEquityFields.type]
        );
      case this.pages.pms:
        return md5(item[PMSFields.name]);
    }
    return '--';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/file-settings/file-settings.component.ts